<template>
  <div class="tophurdle">
    <div>
      <i class="el-icon-s-unfold" v-if="isCollapse" @click='$emit("update:isCollapse", !isCollapse)'></i>
      <i class="el-icon-s-fold" v-else @click='$emit("update:isCollapse", !isCollapse)'></i>
      <span :class="unreadCount?'twinkle':''">
        <font-awesome-icon v-if="imState" icon="comments" @click='$emit("update:imVisible", !imVisible)' style="margin-left: 20px;color:blue;" />
        <font-awesome-icon v-else icon="comments" @click='$message("正在登录，请稍后...或刷新浏览器即可")' style="margin-left: 20px;color:whitesmoke;" />
      </span>
      <el-badge v-if="unreadCount && imState" :value="unreadCount"></el-badge>
      <el-badge v-else-if="unreadCount" :value="unreadCount" type="info"></el-badge>
    </div>
    <div>
      <span>登录账户：{{userinfo.userName}} {{  userinfo.telNo || userinfo.userCode}}<el-divider direction="vertical"></el-divider>登录单位：{{tenantinfo.shortName}}</span>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		isCollapse: {
			type: Boolean,
		},
		imState: {
			type: Boolean,
		},
		imVisible: {
			type: Boolean,
		},
		unreadCount: {
			type: Number,
		},
	},
	data: () => ({
		userinfo: JSON.parse(localStorage.getItem('userinfo')),
		tenantinfo: JSON.parse(localStorage.getItem('tenantinfo')),
	}),
}
</script>
<style lang="scss" scoped>
.tophurdle {
	display: flex;
	overflow: hidden;
	justify-content: space-between;
	padding: 0 20px;
	i,
	svg {
		font-size: 22px;
		vertical-align: middle;
	}
}

.twinkle {
	animation: twinkle 1s linear infinite;
}

@keyframes twinkle {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 1;
	}
	51% {
		opacity: 0.1;
	}
	100% {
		opacity: 0.1;
	}
}
</style>